const useStepAnimations = true;

$('.calculator').each(function () {
    let $calculator = $(this);

    // move form on mobile (below result widget)
    moveCalculatorForm($calculator);
    $(window).on('resize', function() {
        moveCalculatorForm($calculator);
    })

    if (useStepAnimations) {
        // hide steps so they can be animated when answering questions
        $calculator.find('.calculator__step:not(:first-child):not(.calculator__step--disclaimer)').hide();
    }

    $('.calculator__steps', this).on('input change', 'input', function () {
        calculate($calculator);
    });

    // set step numbers
    let $steps = $calculator.find('.calculator__step:not(.calculator__step--disclaimer)'),
        stepCountTotal = $steps.length;

    $steps.each(function() {
        let stepIndex = $(this).index() + 1;

        $(this).find('.calculator__step-number').html(stepIndex + '/' + stepCountTotal);
    });

    calculate($calculator);
});

function calculate($calculator = false) {
    if (!$calculator) return false;

    let $input_persons = $calculator.find('input[name="persons"]'),
        $input_vegetarians = $calculator.find('input[name="vegetarians"]'),
        $input_boat_type = $calculator.find('input[name="boat_type"]:checked'),
        $input_duration = $calculator.find('input[name="duration"]'),
        $input_depart_from = $calculator.find('input[name="depart_from"]:checked'),
        $input_food = $calculator.find('input[name="food"]:checked'),
        $input_drinks_package = $calculator.find('input[name="drinks_package"]:checked');

    let total_cost = 0,
        persons = $input_persons.val(),
        vegetarians = $input_vegetarians.val(),
        hours = $input_duration.val(),
        boat_count = 1;

    let $form = $calculator.find('.calculator__form'),
        $buttons = $calculator.find('.calculator__ready-buttons');

    // place entered values in hidden form inputs with specific classes
    let $formInputPersons = $form.find('.calculator_persons input'),
        $formInputBoatType = $form.find('.calculator_boat_type input'),
        $formInputDuration = $form.find('.calculator_duration input'),
        $formInputDeparture = $form.find('.calculator_departure input'),
        $formInputDrinks = $form.find('.calculator_drinks input'),
        $formInputFood = $form.find('.calculator_food input'),
        $formInputVMR = $form.find('.calculator_vmr input'),
        $formInputCostTotal = $form.find('.calculator_cost_total input');

    if ($formInputPersons.length > 0) $formInputPersons.val('Number of persons ('+vegetarians+' vegetarian) | ' + persons + ' | 0.00');
    if ($formInputDuration.length > 0) $formInputDuration.val(hours);

    let depart_cost = 0,
        depart_tax = 0;

    /*
    *  Boat: calculate boat cost based on boat type, persons, duration and departure location
    */
    if ($input_boat_type.length > 0) {

        let boat_type = $input_boat_type.val(),
            boat_price = 0,
            boat_price_discount = 0; // price after 2 hours

        if ('sloop' === boat_type) {
            boat_price = 197.50;
            boat_price_discount = boat_price; // no discount
        } else if ('cosy' === boat_type) {
            boat_price = 225;
            boat_price_discount = boat_price; // no discount
        } else if ('small' === boat_type) {
            boat_price = 250;
            boat_price_discount = boat_price; // no discount
        } else if ('medium' === boat_type) {
            boat_price = 275;
            boat_price_discount = boat_price; // no discount
        } else if ('large' === boat_type) {
            boat_price = 350;
            boat_price_discount = boat_price; // no discount
        }

        if (hours > 2) {
            boat_price = (boat_price * 2) + (boat_price_discount * (hours - 2));
        } else {
            boat_price = boat_price * hours;
        }

        $calculator.find('.calculator__boat-count').text('');

        // if a lot of persons chosen, selected small boats will be multiplied if selected
        if ('large' !== boat_type) {
            if ('sloop' === boat_type && persons > 35) {
                boat_count = Math.ceil(persons / 35);
            } else if ('cosy' === boat_type && persons > 10) {
                boat_count = Math.ceil(persons / 10);
            } else if ('small' === boat_type && persons > 20) {
                boat_count = Math.ceil(persons / 20);
            } else if ('medium' === boat_type && persons > 30) {
                boat_count = Math.ceil(persons / 30);
            }

            if (boat_count > 1) {
                $calculator.find('.calculator__boat-count').text('(' + boat_count + 'x)');
            }
        }

        let boat_cost = boat_price * boat_count;

        // set gravityforms field for moneybird
        if ($formInputBoatType.length > 0) {
            $formInputBoatType.val($input_boat_type.attr('title') + ' (' + hours + ' uur) ' + ' | ' + boat_count + ' | ' + parseFloat(boat_price).toFixed(2) + ' | 0.09');
        } 

        // display boat costs
        $calculator.find('.calculator__price--boat').text(formatCost(boat_cost));

        // add boat costs to toal
        total_cost = total_cost + boat_cost;

        /*
        *  Departure: calculate costs
        */
        if ($input_depart_from.length > 0) {

            let depart_price = 0,
                depart_tax_multiplier = 0.21;

            if ('outside-centre' === $input_depart_from.val()) {
                depart_price = 90;
            }

            if ('large' === boat_type) {
                depart_price = 180;
            }
 
            depart_cost = depart_cost + (depart_price * boat_count);

            // display departure costs
            $calculator.find('.calculator__price--depart').text(formatCost(depart_cost));

            // set gravityforms field for moneybird
            if ($formInputDeparture.length > 0) {
                $formInputDeparture.val('Departure: ' + $input_depart_from.attr('title') + ' | ' + boat_count + ' | ' + parseFloat(depart_price).toFixed(2) + ' | ' + depart_tax_multiplier);
            }

            // add departure costs to total
            total_cost = depart_cost + total_cost;

            // calculate departure taxes
            depart_tax = depart_tax + (depart_cost * depart_tax_multiplier);
        }
    }

    /*
    *  Food: calculate food cost based on selected food items
    *  this is a checkbox instead of radio, so calculation is a bit different because it can be zero
    */
    let food_cost = 0,
        food_tax = 0;

    if ($input_food.length > 0) {

        let person_price = 0,
            prettyFoodValues = [];

        $input_food.each(function () {

            let selected_food = $(this).val(),
                $inputQuantity = $calculator.find('input[name="' + selected_food + '-qty"]'),
                quantity;
            
            if ($inputQuantity.length > 0) { 
                // if food type has manual quantity input
                quantity = $inputQuantity.val();
            } else { 
                // no quantity select - base quantity on persons count
                if ('platter' === selected_food) {
                    // 1 platter is for 10 persons
                    quantity = Math.ceil(persons / 10); 
                } else {
                    quantity = persons;
                }
            }

            if(quantity == 0 || selected_food.length == 0) {
                return;
            }

            if ('platter' === selected_food) { 
                // 1 platter is for 10 persons
                person_price = 99.95;
            } else if ('cheese-sausage' === selected_food) { // cold appetizers
                person_price = 11.5;
            } else if ('deep-fried' === selected_food) { // warm appetizers
                person_price = 12;
            } else if ('pizza' === selected_food) {
                person_price = 13.95;
            } else if ('hamburger' === selected_food) {
                person_price = 16.95;
            } else if ('sandwich' === selected_food) {
                person_price = 12.5;
            } else if ('bbq' === selected_food) {
                person_price = 28.95;
                // bbq includes one time €75 extra 'for the chef'
                food_cost = food_cost + 75; 
                // add the chef to the prettyFoodValues
                prettyFoodValues.push('Food: BBQ Chef | 1 | 75.00 | 0.21');
            }

            // add food to food costs
            food_cost += (quantity * person_price);

            // add food to prettyFoodValues
            prettyFoodValues.push('Food: ' + $(this).attr('title').trim() + ' | ' + quantity + ' | ' + parseFloat(person_price).toFixed(2) + ' | 0.09');
        });

        // set gravityforms field for moneybird
        if ($formInputFood.length > 0 && prettyFoodValues.length > 0) {
            $formInputFood.val(prettyFoodValues.join(', '));
        }

        // calculate food taxes
        if ($calculator.find('input[name="food"][value="bbq"]:checked').length > 0) {
            // 75 for bbq chef has other tax multiplier
            food_tax = food_tax + ((food_cost - 75) * 0.09) + (75 * 0.21);
        } else {
            food_tax = food_tax + (food_cost * 0.09);
        }
    }

    // add food costs to total
    total_cost = total_cost + food_cost;

    // display food costs
    $calculator.find('.calculator__price--food').text(formatCost(food_cost));

    /*
    *  Drinks: calculate drinks cost based on selected drinks-packages
    */
    let drinks_cost = 0,
        drinks_tax = 0;

    if ($input_drinks_package.length > 0) {

        let prettyDrinksValue = '';
        let selected_drinks = $input_drinks_package.val();
        let person_price = 0;
        let tax_multiplier = 0;

        if(persons == 0 || selected_drinks.length == 0) {
            return;
        }

        if ('standard' === selected_drinks) {
            person_price = 6.50;
            tax_multiplier = 0.09;
        } else if ('basic' === selected_drinks) {
            person_price = 8.00;
            tax_multiplier = 0.21;
        } else if ('medium' === selected_drinks) {
            person_price = 10.00;
            tax_multiplier = 0.21;
        } else if ('luxury' === selected_drinks) {
            person_price = 13.00;
            tax_multiplier = 0.21;
        } else {
            return;
        }

        drinks_cost = drinks_cost + ((persons * person_price) * hours);
        drinks_tax = drinks_tax + (((persons * person_price) * hours) * tax_multiplier);

        prettyDrinksValue = 'Drinks: ' + $input_drinks_package.attr('title') + ' | ' + persons +' | ' +  parseFloat(person_price * hours).toFixed(2) + ' | ' + tax_multiplier;
        
        // set gravityforms field for moneybird
        if ($formInputDrinks.length > 0) {
            $formInputDrinks.val(prettyDrinksValue);
        }
    }

    // display drink costs
    $calculator.find('.calculator__price--drinks').text(formatCost(drinks_cost));

    // add drink costs to total
    total_cost = total_cost + drinks_cost;

    /*
    *  VMR tax
    */
    let vmr_price = 2.6;
    let vmr_cost = persons * vmr_price;

    // display VMR tax costs
    $calculator.find('.calculator__price--vmr').text(formatCost(vmr_cost));
    
    // set gravityforms field for moneybird
    if ($formInputVMR.length > 0) {
        $formInputVMR.val('Vermakelijkhedenretributie | ' + persons + ' | ' + parseFloat(vmr_price).toFixed(2) + ' | 0');
    } 

    // add vmr costs to total
    total_cost = total_cost + vmr_cost;

    // show total cost
    $calculator.find('.calculator__price--total').text(formatCost(total_cost));
    if ($formInputCostTotal.length > 0) $formInputCostTotal.val(formatCost(total_cost));

    // calculate taxes
    let total_cost_tax = total_cost;

    // calculate 9% taxes over total cost (but exclude food and drinks and departure cost (tax already calculated) and VMR tax (because already a tax))
    total_cost_tax = total_cost_tax + (total_cost - (food_cost + drinks_cost + vmr_cost + depart_cost)) * 0.09;

    // add food and drinks and departure tax calculated earlier
    total_cost_tax = total_cost_tax + food_tax + drinks_tax + depart_tax;

    $calculator.find('.calculator__price--total-taxes').text(formatCost(total_cost_tax));

    // show total cost per person
    $calculator.find('.calculator__price--total-per-person').text(formatCost(total_cost_tax / persons));

    // show person count
    $calculator.find('.calculator__person-count').text(persons);

    if (useStepAnimations) {
        calculatorStepAnimations($calculator);
    }

    // show 'request-a-quote' form if all necessary questions have been answered
    if ($form.length > 0) {

        let boat_chosen = false,
            departure_chosen = false,
            drinks_chosen = false;

        if ($input_boat_type.length > 0) boat_chosen = true;
        if ($input_depart_from.length > 0) departure_chosen = true;

        if ($input_drinks_package.length > 0) {
            $input_drinks_package.each(function () {
                // check if selected drinks item has qty select
                let selected_food = $(this).val(),
                    $inputQuantity = $calculator.find('input[name="' + selected_food + '-qty"]');

                if ($inputQuantity.length > 0) {
                    if ($inputQuantity.val() > 0) {
                        drinks_chosen = true;
                    }
                } else {
                    drinks_chosen = true;
                }
            });
        }

        if (boat_chosen && departure_chosen && drinks_chosen) {
            $form.slideDown();

            if ($buttons.length > 0) {
                $buttons.slideDown();
            }
        }
    }
}

function calculatorStepAnimations($calculator = false) {
    if (!$calculator) return false;

    let classStepCompleted = 'calculator__step--completed',
        $currentStep = $calculator.find('.calculator__step:not(.' + classStepCompleted + ')').first(),
        $nextStep = $currentStep.next('.calculator__step');

    if ($nextStep.length > 0) {
        let $input = $currentStep.find('input');

        if ($input.length > 0) {
            let type = $input.attr('type');

            if ('range' === type) {
                let min = $input.attr('min');

                if ($input.val() >= min) {

                    if (!$currentStep.hasClass(classStepCompleted)) {
                        $currentStep.addClass(classStepCompleted);
                        $input.trigger('change'); // for pre-selected inputs
                    }

                    $nextStep.stop().slideDown(150);
                }
            } else if ('radio' === type || 'checkbox' === type) {
                let name = $input.attr('name');

                if ($currentStep.find('input[name="' + name + '"]:checked').length > 0) {

                    if (!$currentStep.hasClass(classStepCompleted)) {
                        $currentStep.addClass(classStepCompleted);
                        $input.trigger('change'); // for pre-selected inputs
                    }

                    $nextStep.stop().slideDown(150);
                }
            }
        }
    }

    let $result = $calculator.find('.calculator__result');

    $result.find('.calculator__result-row').each(function () {
        let $row = $(this),
            $price = $row.find('.calculator__price');

        if ($price.length > 0 && $price.html() !== '0,00') {
            $row.stop().slideDown(150);
        } else {
            $row.stop().slideUp(150);
        }
    });
}

function formatCost(number) {
    number = parseFloat(number).toFixed(2);

    let  str = number + '',
        x = str.split('.'),
        x1 = x[0],
        x2 = x.length > 1 ? ',' + x[1] : '',
        rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }

    return x1 + x2;
}

function moveCalculatorForm($calculator = false) {
    if (!$calculator) return false;

    let $form = $calculator.find('.calculator__form'),
        windowWidth = viewport().width;

    if (windowWidth < 1200) {
        // first check if form has not been moved already
        if ($form.closest('.sidebar-layout').length > 0) {
            $form.appendTo($calculator);
        }
    } else {
        // first check if form has not been moved already
        if (!$form.closest('.sidebar-layout').length > 0) {
            $form.appendTo($calculator.find('.sidebar-layout__content'));
        }
    }
}

// select option if quantity controls are used and value is larger than min value - deselect if equal to 0
$('.calculator .custom-steps__input').on('change', function() {
    let value = $(this).val(),
        $option = $(this).closest('.option'),
        $optionInput = $option.find('.option__input'),
        minVal = $(this).closest('.custom-steps').data('min');

    if (typeof minVal === 'undefined') {
        minVal = 0;
    }

    if (value > minVal) {
        if (!$optionInput.prop('checked')) {
            $option.trigger('click');
        }
    }

    if (value <= 0) {
        if ($optionInput.prop('checked')) {
            $option.trigger('click');
        }
    }
});
